import { render, staticRenderFns } from "./AssemblyFormField.vue?vue&type=template&id=bae716e4&"
import script from "./AssemblyFormField.vue?vue&type=script&lang=js&"
export * from "./AssemblyFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports